<template>
  <div class="paper_page" v-loading="paperLoading" element-loading-text="加载中，请稍候···" element-loading-custom-class="loading_color" element-loading-spinner="el-icon-loading">
    <div class="header_paper" id="header_paper">
      <div class="logo_paper">
        <img src="@/assets/images/header/logo.png" alt />
      </div>
      <div class="paper_name">{{ paper.pname }}</div>
    </div>
    <div class="bread" id="bread">
      <div v-if="model != 'client'">
        <router-link :to="{path: '/tfedu_common/home'}" tag="span" class="first">首页/</router-link>
        <router-link to="/my_evaluation?label=evaluated" tag="span">我的学习</router-link>
        <span class="last">/自评结果</span>
      </div>
      <!-- <div class="test_info"> -->
        <div class="question_info" style="margin-left: 5px">
          <span class="text">已评题数/总题数 ：</span>
          <span class="value">
            <b style="color: #ff9978; font-size: 24px">{{ answer_count }} </b>
            / {{ question_num }}
          </span>
        </div>

        <div class="test_time">
          <span class="text">得分 ：</span>
          <span class="value">{{ self_score }} / {{ paper.fullScore }}</span>
        </div>

        <div>
          <span class="text">作答时间 ： </span>
          <span class="value" style="margin-right : 28px;">{{ answer_time }} </span>
        </div>
      <!-- </div> -->
    </div>

    <div class="main">
      <div class="paper">
        <!--遍历顺序 :  1.子卷 2.大题3.题-->
        <div v-if="paper.gkPapers != null">
          <div v-for="(childPaper, index) in paper.gkPapers" :key="index">
            <!-- <childPaper :selfAssessment="false" :child-paper="child_paper"></childPaper> -->
            <div class="desc-info"
            >{{childPaper.pname}}</div>
            <!-- 
                  如果大题不为空则遍历大题
                -->
            <div v-if="childPaper.gkBigQuestions != null">
              <div
                class="concrete_question"
                v-for="(bigQuestion, index) in childPaper.gkBigQuestions"
                :key="index"
              >
                <div class="desc-info">
                  {{ bigQuestion.name }}
                </div>
                <div
                  v-for="(question, index) in bigQuestion.gkQuestions"
                  :key="index"
                >
                  <template v-if="question.typeCode == 'M'">
                    <compositeQuestion
                      :question="question"
                      :isShowCorrectBtn="false"
                      :isShowAnswerArea="false"
                      :is-show-self-answer="true"
                      :isDisable="true"
                      :self-assessment="true"
                      :subject-id="paper.subjectId"
                    ></compositeQuestion>
                  </template>
                  <template v-else> 
                    <baseQuestion
                      :question="question"
                      :isShowCorrectBtn="false"
                      :isShowAnswerArea="false"
                      :is-show-self-answer="true"
                      :isDisable="true"
                      :self-assessment="true"
                    ></baseQuestion>
                  </template>
                </div>
              </div>
            </div>
            <!-- 
                  如果大题为空,则遍历其他题
              -->
            <div v-if="childPaper.gkQuestions != null">
              <div
                class="concrete_question"
                v-for="(question, index) in childPaper.gkQuestions"
                :key="index"
              >
                <template v-if="question.typeCode == 'M'">
                  <compositeQuestion
                    :question="question"
                    :isShowCorrectBtn="false"
                    :isShowAnswerArea="false"
                    :is-show-self-answer="true"
                    :isDisable="true"
                    :self-assessment="true"
                    :subject-id="paper.subjectId"
                  ></compositeQuestion>
                </template>
                <template v-else>
                  <baseQuestion
                    :question="question"
                    :isShowCorrectBtn="false"
                    :isShowAnswerArea="false"
                    :is-show-self-answer="true"
                    :isDisable="true"
                    :self-assessment="true"
                  ></baseQuestion>
                </template>
              </div>
            </div>
          </div>
        </div>

        
          <div v-if="paper.gkBigQuestions != null">
            <div
              v-for="(bigQuestion, index) in paper.gkBigQuestions"
              :key="index"
            >
                            <div class="desc-info">
                  {{ bigQuestion.name }}
                </div>
              <!-- <bigQuestion :selfAssessment="false" :big-question="bigQuestion"></bigQuestion> -->
              <div
                v-for="(question, index) in bigQuestion.gkQuestions"
                :key="index"
              >
                <template v-if="question.typeCode == 'M'">
                  <compositeQuestion
                    :question="question"
                    :isShowCorrectBtn="false"
                    :isShowAnswerArea="false"
                    :is-show-self-answer="true"
                    :isDisable="true"
                    :self-assessment="true"
                    :subject-id="paper.subjectId"
                  ></compositeQuestion>
                </template>
                <template v-else>
                  <baseQuestion
                    :question="question"
                    :isShowCorrectBtn="false"
                    :isShowAnswerArea="false"
                    :is-show-self-answer="true"
                    :isDisable="true"
                    :self-assessment="true"
                  ></baseQuestion>
                </template>
              </div>
            </div>
          </div>
          <div v-if="paper.gkQuestions != null">
            <!--  -->
            <div v-for="(question, index) in paper.gkQuestions" :key="index">
              <div v-if="question.typeCode == 'M'">
                <compositeQuestion
                  :question="question"
                  :isShowCorrectBtn="false"
                  :isShowAnswerArea="false"
                  :is-show-self-answer="true"
                  :isDisable="true"
                  :self-assessment="true"
                  :subject-id="paper.subjectId"
                ></compositeQuestion>
              </div>
              <div v-else>
                <baseQuestion
                  :question="question"
                  :is-show-correct-btn="false"
                  :isShowAnswerArea="false"
                  :is-show-self-answer="true"
                  :isDisable="true"
                  :self-assessment="true"
                ></baseQuestion>
              </div>
            </div>
            <!--  -->
          </div>
       
      </div>

      <!-- questions -->
      <div class="aside">
        <questionCard
          v-if='questionStatus.length'
          :question-status="questionStatus"
          :question-submit-info="questionSubmitInfo"
          :answer-count="answer_count"
          :paper="paper"
          :question-status2="questionStatus2"
          :fullScore="fullScore"
          :subject-id="paper.subjectId"
          :new-question-status="newqs"
        ></questionCard>
      </div>
      <!-- aside -->
    </div>
  
    <el-image-viewer
      v-if="dialogVisiblePic"
      :on-close="()=>{dialogVisiblePic=false}"
      :url-list="imgs"></el-image-viewer>
    <!-- main -->
  </div>
  <!-- paper -->
</template>

<script>
import questionCard from "./evaluated_card.vue";
import compositeQuestion from "@/components/paper/question/assessment/result_composite_assessment";
import baseQuestion from "@/components/paper/question/question/result_question";
import $ from "jquery";
export default {
  name: "paper",
  components: {
    questionCard,
    compositeQuestion,
    baseQuestion,
    'el-image-viewer':()=>import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      model: '',
      dialogVisiblePic: false,
      imgIndex: 0,
      imgs: [],
      types: [],
      typeEdit: '',
      img_tags: [],
      //记时使用
      answer_time: 0, //考试时间
      question_num: 0,
      count_down: "00:00:00", //记时显示用
      out_time: "00:00:00", //超时时间
      //试卷信息
      paper: {},
      //问题id数组
      qnArray: [],
      questionStatus: [], //未批改题的状态
      questionStatus2 : [],//已批改的题的状态
      //提交的试卷信息
      questionSubmitInfo: {},
      test_id: 0,
      answer_count: 0,
      // 自评页需要参数
      selfAssessment: {
        qType: "assessment",
        assessmentShow: true,
      },
      paperLoading : true,
      self_score: 0,
      allscore: 0,
      //画图的参数
      dialogSubmitVisible: true,
      pieChartData: [],
      pieOtherData: [],
      pieOtherData2: [],
      otherOffsetAngle: 0,
      question_tab: 1,
      fullScore : 0,
      newqs: {}, // 为实现复合题选项卡添加
      newqsIndex: -1
    };
  },
  computed: {
    isShowQuestion: function () {
      return function (question) {
        let isShow = false;
        if(question.subQuestions){
          question.subQuestions.forEach((element) => {
          if (element.original == this.question_tab) isShow = true;
        });
        return isShow;
        }
        
      };
    },
  },
  methods: {
    //图片预览
    prev(){
      this.imgIndex = this.imgIndex - 1;
    },
    next(){
      this.imgIndex = this.imgIndex + 1;
    },
    interval() {
      /*  计时器
				东八区00：00：00为记时开始时间
			*/
      //1.获得开始时间 开始的毫秒数
      let start_millisecond = -8 * 60 * 60 * 1000;
      let start_time = new Date(start_millisecond);
      //2.获得结束时间 结束的毫秒数
      // let end_millisecond = start_millisecond + this.answer_time * 60 * 1000;
      this.count_down = start_time.toTimeString().split(" ")[0];
    },
    //初始化试卷
    initPage(qs) {
      this.paperLoading = true;
      let id = this.$route.query.paper_id;
      this.$HTTP
        .executeGet(this.$APIS.GET_PAPER_BY_ID + id, this)
        .then((res) => {
          if (res.msg == "Success!") {
            //获得整个试卷的信息
            let gkpaper = res.data;
            this.paper = gkpaper;
            let subjectId = gkpaper.subjectId;
            if (gkpaper.fullScore == undefined) {
              gkpaper.fullScore = 0;
            }

            this.getTestId(gkpaper);
            //获得试卷的考试时间
            this.answer_time = res.data.duration;
            //获得所有的题号id
            let qc = 0;
            let order = 1;
            let qs = [];

            let major_question_count = 0;
            let major_quesiton_score = 0;

            let radio_question_number = 0;
            let multi_question_number = 0;
            let judge_question_number = 0;
            let radio_question_score = 0;
            let multi_question_score = 0;
            let judge_question_score = 0;
            if (gkpaper.gkPapers != undefined) {
              gkpaper.gkPapers.forEach((gp) => {
                if (gp.gkBigQuestions != undefined) {
                  gp.gkBigQuestions.forEach((gbq) => {
                    if (gbq.gkQuestions != undefined) {
                      gbq.gkQuestions.forEach((gq) => {
                        gq.status = false;

                        if (gq.typeCode == "M") {
                          if (gq.subQuestions != undefined && gq.subQuestions != null && gq.subQuestions.length) {
                            qc += gq.subQuestions.length;

                            gq.subQuestions.forEach((sq) => {
                              sq.status = false;
                              sq.questionOrder = order++;
                              let major_question = ["E", "S"];
                              if (
                                major_question.indexOf(sq.typeCode) == -1
                                  ? true
                                  : false
                              ) {
                                major_question_count++;
                                major_quesiton_score += sq.score;
                              }
                              if (sq.typeCode == "A") {
                                radio_question_number++;
                                radio_question_score += sq.score;
                              }
                              if (sq.typeCode == "B") {
                                multi_question_number++;
                                multi_question_score += sq.score;
                              }
                              if (sq.typeCode == "C") {
                                judge_question_number++;
                                multi_question_score += sq.score;
                              }
                              qs.push({
                                parent_id: gq.original,
                                parent_typeId: gq.typeId,
                                card_originalName : subjectId == 9 || subjectId == 11 || subjectId == 16 || subjectId == 15 || subjectId == 17 ? sq.originalName : gq.originalName + "." + sq.originalName,
                                order: sq.original,
                                status: false,
                                correct: false,
                                score: 0, //得分
                                type_code: sq.typeCode,
                                question_score: sq.score, //题的分数
                                self_answer: undefined,
                                answer: sq.answer ? sq.answer.trimHeadTailTag("p") : '',
                                id: sq.id,
                                audit_status: true,
                                originalName: sq.originalName.trim(),
                                answerUnicity : sq.answerUnicity,
                                type_id : sq.typeId,
                                parentName: (this.paper.subjectId == 10 || this.paper.subjectId == 12 || this.paper.subjectId == 13 || this.paper.subjectId == 14) ? gq.originalName : ''
                                // major_question.indexOf(sq.typeCode) == -1
                                //   ? true
                                //   : false, //批改状态
                              });

                              if (!this.newqs.hasOwnProperty(gq.originalName)) {
                                this.$set(this.newqs, gq.originalName, [])
                                this.newqs[gq.originalName].push({
                                  index: ++this.newqsIndex,
                                  name: sq.originalName.trim(),
                                  status: false,
                                  id: sq.id,
                                  original: sq.original
                                })
                              } else {
                                this.newqs[gq.originalName].push({
                                  index: ++this.newqsIndex,
                                  name: sq.originalName.trim(),
                                  status: false,
                                  id: sq.id,
                                  original: sq.original
                                })
                              }
                            });
                          }
                        } else {
                          gq.questionOrder = order++;
                          qc++;
                          let major_question = ["E", "S"];
                          if (
                            major_question.indexOf(gq.typeCode) == -1
                              ? true
                              : false
                          ) {
                            major_question_count++;
                            major_quesiton_score += gq.score;
                          }
                          if (gq.typeCode == "A") {
                            radio_question_number++;
                            radio_question_score += gq.score;
                          }
                          if (gq.typeCode == "B") {
                            multi_question_number++;
                            multi_question_score += gq.score;
                          }
                          if (gq.typeCode == "C") {
                            judge_question_number++;
                            multi_question_score += gq.score;
                          }
                          qs.push({
                            parent_id: gq.original,
                            parent_typeId: gq.typeId,
                            card_originalName : gq.originalName,
                            order: gq.original,
                            status: false,
                            correct: false,
                            score: 0,
                            type_code: gq.typeCode,
                            question_score: gq.score,
                            self_answer: undefined,
                            answer: gq.answer ? gq.answer.trimHeadTailTag("p") : '',
                            id: gq.id,
                            audit_status: true,
                            originalName : gq.originalName.trim(),
                            answerUnicity : gq.answerUnicity,
                            type_id : gq.typeId
                            // major_question.indexOf(gq.typeCode) == -1
                            //   ? true
                            //   : false, //批改状态
                          });

                          if (!this.newqs.hasOwnProperty(gq.originalName)) {
                            this.$set(this.newqs, gq.originalName, [])
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: gq.originalName.trim(),
                              status: false,
                              id: gq.id,
                              original: gq.original
                            })
                          } else {
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: gq.originalName.trim(),
                              status: false,
                              id: gq.id,
                              original: gq.original
                            })
                          }
                        }
                      });
                    }
                  });
                }
                if (gp.gkQuestions != undefined) {
                  gp.gkQuestions.forEach((gq) => {
                    gq.status = false;

                    if (gq.typeCode == "M") {
                      if(gq.subQuestions != null && gq.subQuestions != undefined && gq.subQuestions.length) {
                        qc += gq.subQuestions.length;
                        gq.subQuestions.forEach((sq) => {
                          sq.status = false;
                          sq.questionOrder = order++;
                          let major_question = ["E", "S"];
                          if (
                            major_question.indexOf(sq.typeCode) == -1
                              ? true
                              : false
                          ) {
                            major_question_count++;
                            major_quesiton_score += sq.score;
                          }
                          if (sq.typeCode == "A") {
                            radio_question_number++;
                            radio_question_score += sq.score;
                          }
                          if (sq.typeCode == "B") {
                            multi_question_number++;
                            multi_question_score += sq.score;
                          }
                          if (sq.typeCode == "C") {
                            judge_question_number++;
                            multi_question_score += sq.score;
                          }
                          qs.push({
                            parent_id: gq.original,
                            parent_typeId: gq.typeId,
                            card_originalName : subjectId == 9 || subjectId == 11 || subjectId == 16 || subjectId == 15 || subjectId == 17 ? sq.originalName : gq.originalName + "." + sq.originalName,
                            order: sq.original,
                            status: false,
                            correct: false,
                            score: 0,
                            type_code: sq.typeCode,
                            question_score: sq.score,
                            self_answer: undefined,
                            answer: sq.answer ? sq.answer.trimHeadTailTag("p") : '',
                            id: sq.id,
                            audit_status: true,
                            originalName : sq.originalName.trim(),
                            answerUnicity : sq.answerUnicity,
                            type_id : sq.typeId,
                            parentName: (this.paper.subjectId == 10 || this.paper.subjectId == 12 || this.paper.subjectId == 13 || this.paper.subjectId == 14) ? gq.originalName : ''
                            // major_question.indexOf(sq.typeCode) == -1
                            //   ? true
                            //   : false, //批改状态
                          });
                          if (!this.newqs.hasOwnProperty(gq.originalName)) {
                            this.$set(this.newqs, gq.originalName, [])
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: sq.originalName.trim(),
                              status: false,
                              id: sq.id,
                              original: sq.original
                            })
                          } else {
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: sq.originalName.trim(),
                              status: false,
                              id: sq.id,
                              original: sq.original
                            })
                          }
                        });
                      }
                    } else {
                      gq.questionOrder = order++;
                      qc++;
                      let major_question = ["E", "S"];
                      if (
                        major_question.indexOf(gq.typeCode) == -1 ? true : false
                      ) {
                        major_question_count++;
                        major_quesiton_score += gq.score;
                      }
                      if (gq.typeCode == "A") {
                        radio_question_number++;
                        radio_question_score += gq.score;
                      }
                      if (gq.typeCode == "B") {
                        multi_question_number++;
                        multi_question_score += gq.score;
                      }
                      if (gq.typeCode == "C") {
                        judge_question_number++;
                        multi_question_score += gq.score;
                      }
                      qs.push({
                        parent_id: gq.original,
                        parent_typeId: gq.typeId,
                        card_originalName : gq.originalName,
                        order: gq.original,
                        status: false,
                        correct: false,
                        type_code: gq.typeCode,
                        question_score: gq.score,
                        score: 0,
                        self_answer: undefined,
                        answer: gq.answer ? gq.answer.trimHeadTailTag("p") : '',
                        id: gq.id,
                        audit_status: true,
                        originalName : gq.originalName.trim(),
                        answerUnicity : gq.answerUnicity,
                        type_id : gq.typeId
                        // major_question.indexOf(gq.typeCode) == -1
                        //   ? true
                        //   : false, //批改状态
                      });
                      if (!this.newqs.hasOwnProperty(gq.originalName)) {
                        this.$set(this.newqs, gq.originalName, [])
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: gq.originalName.trim(),
                          status: false,
                          id: gq.id,
                          original: gq.original
                        })
                      } else {
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: gq.originalName.trim(),
                          status: false,
                          id: gq.id,
                          original: gq.original
                        })
                      }
                    }
                  });
                }
              });
            }

            if (gkpaper.gkBigQuestions != undefined) {
              gkpaper.gkBigQuestions.forEach((gbq) => {
                if (gbq.gkQuestions != undefined) {
                  gbq.gkQuestions.forEach((gq) => {
                    gq.status = false;

                    if (gq.typeCode == "M") {
                      if (gq.subQuestions != null && gq.subQuestions != undefined && gq.subQuestions.length) {
                        qc += gq.subQuestions.length;
                        gq.subQuestions.forEach((sq) => {
                          sq.status = false;
                          sq.questionOrder = order++;
                          let major_question = ["E", "S"];
                          if (
                            major_question.indexOf(sq.typeCode) == -1
                              ? true
                              : false
                          ) {
                            major_question_count++;
                            major_quesiton_score += sq.score;
                          }
                          if (sq.typeCode == "A") {
                            radio_question_number++;
                            radio_question_score += sq.score;
                          }
                          if (sq.typeCode == "B") {
                            multi_question_number++;
                            multi_question_score += sq.score;
                          }
                          if (sq.typeCode == "C") {
                            judge_question_number++;
                            multi_question_score += sq.score;
                          }
                          qs.push({
                            parent_id: gq.original,
                            parent_typeId: gq.typeId,
                            card_originalName : subjectId == 9 || subjectId == 11 || subjectId == 16 || subjectId == 15 || subjectId == 17 ? sq.originalName : gq.originalName + "." + sq.originalName,
                            order: sq.original,
                            status: false,
                            correct: false,
                            score: 0,
                            type_code: sq.typeCode,
                            question_score: sq.score,
                            self_answer: undefined,
                            answer: sq.answer ? sq.answer.trimHeadTailTag("p") : '',
                            id: sq.id,
                            audit_status: true,
                            originalName : sq.originalName.trim(),
                            answerUnicity : sq.answerUnicity,
                            type_id : sq.typeId,
                            parentName: (this.paper.subjectId == 10 || this.paper.subjectId == 12 || this.paper.subjectId == 13 || this.paper.subjectId == 14) ? gq.originalName : ''
                            // major_question.indexOf(sq.typeCode) == -1
                            //   ? true
                            //   : false, //批改状态
                          });

                          if (!this.newqs.hasOwnProperty(gq.originalName)) {
                            this.$set(this.newqs, gq.originalName, [])
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: sq.originalName.trim(),
                              status: false,
                              id: sq.id,
                              original: sq.original
                            })
                          } else {
                            this.newqs[gq.originalName].push({
                              index: ++this.newqsIndex,
                              name: sq.originalName.trim(),
                              status: false,
                              id: sq.id,
                              original: sq.original
                            })
                          }
                        });
                      }
                    } else {
                      gq.questionOrder = order++;
                      qc++;
                      let major_question = ["E", "S"];
                      if (
                        major_question.indexOf(gq.typeCode) == -1 ? true : false
                      ) {
                        major_question_count++;
                        major_quesiton_score += gq.score;
                      }
                      if (gq.typeCode == "A") {
                        radio_question_number++;
                        radio_question_score += gq.score;
                      }
                      if (gq.typeCode == "B") {
                        multi_question_number++;
                        multi_question_score += gq.score;
                      }
                      if (gq.typeCode == "C") {
                        judge_question_number++;
                        multi_question_score += gq.score;
                      }
                      qs.push({
                        parent_id: gq.original,
                        parent_typeId: gq.typeId,
                        card_originalName :  gq.originalName ,
                        order: gq.original,
                        status: false,
                        correct: false,
                        type_code: gq.typeCode,
                        question_score: gq.score,
                        score: 0,
                        self_answer: undefined,
                        answer: gq.answer ? gq.answer.trimHeadTailTag("p") : '',
                        id: gq.id,
                        audit_status: true,
                        originalName : gq.originalName.trim(),
                        answerUnicity : gq.answerUnicity,
                        type_id : gq.typeId
                        // major_question.indexOf(gq.typeCode) == -1
                        //   ? true
                        //   : false, //批改状态
                      });

                      if (!this.newqs.hasOwnProperty(gq.originalName)) {
                        this.$set(this.newqs, gq.originalName, [])
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: gq.originalName.trim(),
                          status: false,
                          id: gq.id,
                          original: gq.original
                        })
                      } else {
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: gq.originalName.trim(),
                          status: false,
                          id: gq.id,
                          original: gq.original
                        })
                      }
                    }
                  });
                }
              });
            }

            if (gkpaper.gkQuestions != undefined) {
              gkpaper.gkQuestions.forEach((gq) => {
                gq.status = false;

                if (gq.typeCode == "M") {
                  if (gq.subQuestions != null && gq.subQuestions != undefined && gq.subQuestions.length) {
                    qc += gq.subQuestions.length;
                    gq.subQuestions.forEach((sq) => {
                      sq.status = false;
                      sq.questionOrder = order++;
                      let major_question = ["E", "S"];
                      if (
                        major_question.indexOf(sq.typeCode) == -1 ? true : false
                      ) {
                        major_question_count++;
                        major_quesiton_score += sq.score;
                      }
                      if (sq.typeCode == "A") {
                        radio_question_number++;
                        radio_question_score += sq.score;
                      }
                      if (sq.typeCode == "B") {
                        multi_question_number++;
                        multi_question_score += sq.score;
                      }
                      if (sq.typeCode == "C") {
                        judge_question_number++;
                        multi_question_score += sq.score;
                      }
                      qs.push({
                        parent_id: gq.original,
                        parent_typeId: gq.typeId,
                        card_originalName : subjectId == 9 || subjectId == 11 || subjectId == 16 || subjectId == 15 || subjectId == 17 ? sq.originalName : gq.originalName + "." + sq.originalName,
                        order: sq.original,
                        status: false,
                        correct: false,
                        score: 0,
                        type_code: sq.typeCode,
                        question_score: sq.score,
                        self_answer: undefined,
                        answer: sq.answer ? sq.answer.trimHeadTailTag("p") : '',
                        id: sq.id,
                        audit_status: true,
                        originalName: sq.originalName.trim(),
                        answerUnicity : sq.answerUnicity,
                        type_id : sq.typeId,
                        parentName: (this.paper.subjectId == 10 || this.paper.subjectId == 12 || this.paper.subjectId == 13 || this.paper.subjectId == 14) ? gq.originalName : ''
                        // major_question.indexOf(sq.typeCode) == -1
                        //   ? true
                        //   : false, //批改状态
                      });

                      if (!this.newqs.hasOwnProperty(gq.originalName)) {
                        this.$set(this.newqs, gq.originalName, [])
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: sq.originalName.trim(),
                          status: false,
                          id: sq.id,
                          original: sq.original
                        })
                      } else {
                        this.newqs[gq.originalName].push({
                          index: ++this.newqsIndex,
                          name: sq.originalName.trim(),
                          status: false,
                          id: sq.id,
                          original: sq.original
                        })
                      }
                    });
                  }
                } else {
                  gq.questionOrder = order++;
                  qc++;
                  let major_question = ["E", "S"];
                  if (
                    major_question.indexOf(gq.typeCode) == -1 ? true : false
                  ) {
                    major_question_count++;
                    major_quesiton_score += gq.score;
                  }
                  if (gq.typeCode == "A") {
                    radio_question_number++;
                    radio_question_score += gq.score;
                  }
                  if (gq.typeCode == "B") {
                    multi_question_number++;
                    multi_question_score += gq.score;
                  }
                  if (gq.typeCode == "C") {
                    judge_question_number++;
                    multi_question_score += gq.score;
                  }
                  qs.push({
                    parent_id: gq.original,
                    parent_typeId: gq.typeId,
                    card_originalName :  gq.originalName ,
                    order: gq.original,
                    status: false,
                    correct: false,
                    type_code: gq.typeCode,
                    question_score: gq.score,
                    score: 0,
                    self_answer: undefined,
                    answer: gq.answer ? gq.answer.trimHeadTailTag("p") : '',
                    id: gq.id,
                    audit_status: true,
                    originalName : gq.originalName.trim(),
                    answerUnicity : gq.answerUnicity,
                    type_id : gq.typeId
                    // major_question.indexOf(gq.typeCode) == -1
                    //   ? true
                    //   : false, //批改状态
                  });
                  // this.$set(this.obj,'e',02)

                  if (!this.newqs.hasOwnProperty(gq.originalName)) {
                    this.$set(this.newqs, gq.originalName, [])
                    this.newqs[gq.originalName].push({
                      index: ++this.newqsIndex,
                      name: gq.originalName.trim(),
                      status: false,
                      id: gq.id,
                      original: gq.original
                    })
                  } else {
                    this.newqs[gq.originalName].push({
                      index: ++this.newqsIndex,
                      name: gq.originalName.trim(),
                      status: false,
                      id: gq.id,
                      original: gq.original
                    })
                  }

                }
              });
            }
            this.question_num = qc;
            gkpaper.question_count = qc;
            this.objective_score =
              radio_question_score +
              multi_question_score +
              judge_question_score;
            this.major_quesiton_score = major_quesiton_score;
            this.full_score = gkpaper.fullScore;
            this.question_tab = qs[0].order;
            // this.question_tab = 62;

            this.questionStatus = qs;

            this.questionNumber = qs.length

            this.dialogLoading = false;

            // this.loadPdfHandler(gkpaper.id)
            this.interval();
          } else {
            this.$message.error("加载试卷信息失败!");
          }
          this.paperLoading = false;
        });


        
      // this.$HTTP
      //   .executeGet(this.$APIS.GET_PAPER_BY_ID + id, this)
      //   .then((res) => {
      //     if (res.msg == "Success!") {
      //       this.paperLoading = false;
      //       //获得整个试卷的信息
      //       let gkpaper = res.data;
      //       if (gkpaper.fullScore == undefined) {
      //         gkpaper.fullScore = 0;
      //       }
      //       this.fullScore = gkpaper.fullScore;
      //       this.paper = gkpaper;
      //       //获得试卷的考试时间
      //       // this.answer_time = res.data.duration;
      //       //获得所有的题号id
      //       let qc = 0;
      //       let order = 1;
      //       //主观题
      //       // let major_question_count = 0; //主观题总数
      //       // let major_quesiton_score = 0; //主观题总分
      //       // let major_correct_score = 0; //主观题正确分数
      //       // let major_unaduit_score = 0; //主观题未批改的分数
      //       // let major_error_score = 0; //主观题错误分数
      //       //客观题
      //       // let objective_question_count = 0; //客观题总数
      //       // let objective_question_score = 0; //客观题总分
      //       // let objective_correct_score = 0; //客观题正确分数
      //       // let objective_error_score = 0; //客观题错误分数

      //       //主观题的typeCode
      //       let majorTypes = ["E", "S"]; //E是填空题,如果填空的答案answerUncitiy是唯一的则为客观题

      //       if (gkpaper.gkPapers != undefined) {
      //         gkpaper.gkPapers.forEach((gp) => {
      //           if (gp.gkBigQuestions != undefined) {
      //             gp.gkBigQuestions.forEach((gbq) => {
      //               if (gbq.gkQuestions != undefined) {
      //                 gbq.gkQuestions.forEach((gq) => {
      //                   if (gq.typeCode == "M") {
      //                     if(gq.subQuestions){
      //                     qc += gq.subQuestions.length;
      //                     gq.subQuestions.forEach((sq) => {
      //                       qs.forEach((item) => {
      //                         if (item.id == sq.id) {
      //                           item.originalName = sq.originalName
      //                           item.parent_id = gq.original;
      //                           item.parent_typeId = gq.typeId;
      //                           this.allscore += sq.score;
      //                           item.order = sq.original;
      //                           sq.self_answer = item.self_answer;
      //                           sq.self_score = item.score;
      //                           sq.auditStatus = item.auditStatus;
      //                           sq.tempAuditStatus = item.auditStatus;
      //                           sq.correct = item.correct;
      //                           sq.note = item.note;
      //                           sq.paper_id = this.questionSubmitInfo.paper_id;
      //                           sq.test_id = this.questionSubmitInfo.test_id;
      //                           // if (!(majorTypes.indexOf(sq.typeCode) == -1)) {
      //                           //   // major_question_count++;
      //                           //   // major_quesiton_score += sq.score;
      //                           //   // if (!item.auditStatus && item.status) {
      //                           //   //   // major_unaduit_score += sq.score;
      //                           //   // }
      //                           //   // if (item.correct && item.status) {
      //                           //   //   // major_correct_score += sq.score;
      //                           //   // } else {
      //                           //   //   major_error_score += sq.score;
      //                           //   // }
      //                           // } else {
      //                           //   // objective_question_count++;
      //                           //   // objective_question_score += sq.score;
      //                           //   if (item.correct) {
      //                           //     objective_correct_score += sq.score;
      //                           //   } else {
      //                           //     objective_error_score += sq.score;
      //                           //   }
      //                           // }

      //                           if (!this.newqs.hasOwnProperty(gq.original)) {
      //                             this.$set(this.newqs, gq.original, [])
      //                             this.newqs[gq.original].push({
      //                               index: ++this.newqsIndex,
      //                               name: sq.originalName.trim(),
      //                               status: item.correct,
      //                               id: sq.id,
      //                               original: sq.original
      //                             })
      //                           } else {
      //                             this.newqs[gq.original].push({
      //                               index: ++this.newqsIndex,
      //                               name: sq.originalName.trim(),
      //                               status: item.correct,
      //                               id: sq.id,
      //                               original: sq.original
      //                             })
      //                           }
      //                         }
      //                       });
      //                       sq.questionOrder = order++;
      //                     });
      //                   }
      //                  } else {
      //                     gq.questionOrder = order++;
      //                     qs.forEach((item) => {
      //                       if (item.id == gq.id) {
      //                         item.originalName = gq.originalName
      //                         item.parent_id = gq.original;
      //                         item.parent_typeId = gq.typeId;
      //                         gq.note = item.note;
      //                         this.allscore += gq.score;
      //                         item.order = gq.original;
      //                         qc++;
      //                         gq.self_answer = item.self_answer;
      //                         gq.self_score = item.score;
      //                         gq.auditStatus = item.auditStatus;
      //                         gq.correct = item.correct;
      //                         gq.tempAuditStatus = item.auditStatus;
      //                         gq.paper_id = this.questionSubmitInfo.paper_id;
      //                         gq.test_id = this.questionSubmitInfo.test_id;
      //                         // if (!(majorTypes.indexOf(gq.typeCode) == -1)) {
      //                         //   // major_question_count++;
      //                         //   // major_quesiton_score += gq.score;
      //                         //   // if (!item.auditStatus) {
      //                         //   //   major_unaduit_score += gq.score;
      //                         //   // }
      //                         //   // if (item.correct) {
      //                         //   //   // major_correct_score += item.score;
      //                         //   // } else {
      //                         //   //   major_error_score += item.score;
      //                         //   // }
      //                         // } else {
      //                         //   // objective_question_count++;
      //                         //   // objective_question_score += gq.score;
      //                         //   if (item.correct) {
      //                         //     objective_correct_score += gq.score;
      //                         //   } else {
      //                         //     objective_error_score += gq.score;
      //                         //   }
      //                         // }

      //                         if (!this.newqs.hasOwnProperty(gq.original)) {
      //                           this.$set(this.newqs, gq.original, [])
      //                           this.newqs[gq.original].push({
      //                             index: ++this.newqsIndex,
      //                             name: gq.originalName.trim(),
      //                             status: item.correct,
      //                             id: gq.id,
      //                             original: gq.original
      //                           })
      //                         } else {
      //                           this.newqs[gq.original].push({
      //                             index: ++this.newqsIndex,
      //                             name: gq.originalName.trim(),
      //                             status: item.correct,
      //                             id: gq.id,
      //                             original: gq.original
      //                           })
      //                         }
      //                       }
      //                     });
      //                   }
      //                 });
      //               }
      //             });
      //           }
      //           if (gp.gkQuestions != undefined) {
      //           gp.gkQuestions.forEach((gq) => {
      //             if (gq.typeCode == "M") {
      //               qc += gq.subQuestions.length;
      //               gq.subQuestions.forEach((sq) => {
      //                 sq.questionOrder = order++;
      //                 qs.forEach((item) => {
      //                   if (item.id == sq.id) {
      //                     item.originalName = sq.originalName
      //                     item.parent_id = gq.original;
      //                     item.parent_typeId = gq.typeId;
      //                     sq.note = item.note;
      //                     item.order = sq.original;
      //                     sq.self_answer = item.self_answer;
      //                     sq.self_score = item.score;
      //                     sq.auditStatus = item.auditStatus;
      //                     sq.correct = item.correct;
      //                     sq.tempAuditStatus = item.auditStatus;
      //                     this.allscore += sq.score;
      //                     sq.paper_id = this.questionSubmitInfo.paper_id;
      //                     sq.test_id = this.questionSubmitInfo.test_id;
      //                     // if (!(majorTypes.indexOf(sq.typeCode) == -1)) {
      //                     //   // major_question_count++;
      //                     //   // major_quesiton_score += sq.score;
      //                     //   // if (!item.auditStatus && item.status) {
      //                     //   //   major_unaduit_score += sq.score;
      //                     //   // }
      //                     //   // if (item.correct && item.status) {
      //                     //   //   // major_correct_score += item.score;
      //                     //   // } else {
      //                     //   //   major_error_score += item.score;
      //                     //   // }
      //                     // } else {
      //                     //   // objective_question_count++;
      //                     //   // objective_question_score += sq.score;
      //                     //   if (item.correct) {
      //                     //     objective_correct_score += sq.score;
      //                     //   } else {
      //                     //     objective_error_score += sq.score;
      //                     //   }
      //                     // }

      //                     if (!this.newqs.hasOwnProperty(gq.original)) {
      //                       this.$set(this.newqs, gq.original, [])
      //                       this.newqs[gq.original].push({
      //                         index: ++this.newqsIndex,
      //                         name: sq.originalName.trim(),
      //                         status: item.correct,
      //                         id: sq.id,
      //                         original: sq.original
      //                       })
      //                     } else {
      //                       this.newqs[gq.original].push({
      //                         index: ++this.newqsIndex,
      //                         name: sq.originalName.trim(),
      //                         status: item.correct,
      //                         id: sq.id,
      //                         original: sq.original
      //                       })
      //                     }
      //                   }
      //                 });
      //               });
      //             } else {
      //               gq.questionOrder = order++;
      //               qc++;
      //               qs.forEach((item) => {
      //                 if (item.id == gq.id) {
      //                   item.originalName = gq.originalName

      //                   item.parent_id = gq.original;
      //                     item.parent_typeId = gq.typeId;
      //                   gq.note = item.note;
      //                   gq.self_score = item.score;
      //                   gq.auditStatus = item.auditStatus;
      //                   gq.correct = item.correct;
      //                   item.order = gq.original;
      //                   gq.paper_id = this.questionSubmitInfo.paper_id;
      //                   gq.test_id = this.questionSubmitInfo.test_id;
      //                   gq.tempAuditStatus = item.auditStatus;
      //                   this.allscore += gq.score;
      //                   if (item.self_answer != undefined) {
      //                     let type = gq.typeCode;
      //                     if (type == "A" || type == "C") {
      //                       gq.self_answer = item.self_answer;
      //                     }
      //                     if (type == "B") {
      //                       gq.self_answer = item.self_answer;
      //                     }
      //                     if (type == "C") {
      //                     }
      //                     if (type == "E") {
      //                       gq.self_answer = item.self_answer;
      //                     }
      //                     if (type == "S") {
      //                       gq.self_answer = item.self_answer;
      //                     }
      //                   }
      //                   // if (!(majorTypes.indexOf(gq.typeCode) == -1)) {
      //                   //   // major_question_count++;
      //                   //   // major_quesiton_score += gq.score;
      //                   //   // if (!item.auditStatus) {
      //                   //   //   major_unaduit_score += gq.score;
      //                   //   // }
      //                   //   // if (item.correct) {
      //                   //   //   // major_correct_score += gq.score;
      //                   //   // } else {
      //                   //   //   major_error_score += gq.score;
      //                   //   // }
      //                   // } else {
      //                   //   // objective_question_count++;
      //                   //   // objective_question_score += gq.score;
      //                   //   if (item.correct) {
      //                   //     objective_correct_score += gq.score;
      //                   //   } else {
      //                   //     objective_error_score += gq.score;
      //                   //   }
      //                   // }

      //                   if (!this.newqs.hasOwnProperty(gq.original)) {
      //                     this.$set(this.newqs, gq.original, [])
      //                     this.newqs[gq.original].push({
      //                       index: ++this.newqsIndex,
      //                       name: gq.originalName.trim(),
      //                       status: item.correct,
      //                       id: gq.id,
      //                       original: gq.original
      //                     })
      //                   } else {
      //                     this.newqs[gq.original].push({
      //                       index: ++this.newqsIndex,
      //                       name: gq.originalName.trim(),
      //                       status: item.correct,
      //                       id: gq.id,
      //                       original: gq.original
      //                     })
      //                   }
      //                 }
      //               });
      //             }
      //           });
            
      //           }
      //         });
      //       }
      //       if (gkpaper.gkBigQuestions != undefined) {
      //         gkpaper.gkBigQuestions.forEach((gbq) => {
      //           if (gbq.gkQuestions != undefined) {
      //             gbq.gkQuestions.forEach((gq) => {
      //               if (gq.typeCode == "M") {
      //                 qc += gq.subQuestions.length;
      //                 gq.subQuestions.forEach((sq) => {
      //                   sq.questionOrder = order++;
      //                   qs.forEach((item) => {
      //                     if (item.id == sq.id) {
      //                       item.originalName = sq.originalName
      //                       item.parent_id = gq.original;
      //                     item.parent_typeId = gq.typeId;
      //                       sq.note = item.note;
      //                       item.order = sq.original;
      //                       sq.self_answer = item.self_answer;
      //                       sq.self_score = item.score;
      //                       sq.auditStatus = item.auditStatus;
      //                       sq.correct = item.correct;
      //                       sq.tempAuditStatus = item.auditStatus;
      //                       sq.paper_id = this.questionSubmitInfo.paper_id;
      //                       sq.test_id = this.questionSubmitInfo.test_id;
      //                       this.allscore += sq.score;

      //                       // if (!(majorTypes.indexOf(sq.typeCode) == -1)) {
      //                       //   // major_question_count++;
      //                       //   // major_quesiton_score += sq.score;
      //                       //   // if (!item.auditStatus && item.status) {
      //                       //   //   major_unaduit_score += sq.score;
      //                       //   // }
      //                       //   // if (item.correct && item.status) {
      //                       //   //   // major_correct_score += item.score;
      //                       //   // } else {
      //                       //   //   major_error_score += item.score;
      //                       //   // }
      //                       // } else {
      //                       //   // objective_question_count++;
      //                       //   // objective_question_score += sq.score;
      //                       //   if (item.correct) {
      //                       //     objective_correct_score += sq.score;
      //                       //   } else {
      //                       //     objective_error_score += sq.score;
      //                       //   }
      //                       // }

      //                       if (!this.newqs.hasOwnProperty(gq.original)) {
      //                         this.$set(this.newqs, gq.original, [])
      //                         this.newqs[gq.original].push({
      //                           index: ++this.newqsIndex,
      //                           name: sq.originalName.trim(),
      //                           status: item.correct,
      //                           id: sq.id,
      //                           original: sq.original
      //                         })
      //                       } else {
      //                         this.newqs[gq.original].push({
      //                           index: ++this.newqsIndex,
      //                           name: sq.originalName.trim(),
      //                           status: item.correct,
      //                           id: sq.id,
      //                           original: sq.original
      //                         })
      //                       }
      //                     }
      //                   });
      //                 });
      //               } else {
      //                 gq.questionOrder = order++;
      //                 qc++;
      //                 qs.forEach((item) => {
      //                   if (item.id == gq.id) {
      //                     item.originalName = gq.originalName
      //                     item.parent_id = gq.original;
      //                     item.parent_typeId = gq.typeId;
      //                     gq.note = item.note;
      //                     gq.self_score = item.score;
      //                     gq.auditStatus = item.auditStatus;
      //                     gq.correct = item.correct;
      //                     item.order = gq.original;
      //                     gq.tempAuditStatus = item.auditStatus;
      //                     gq.paper_id = this.questionSubmitInfo.paper_id;
      //                     gq.test_id = this.questionSubmitInfo.test_id;
      //                     this.allscore += gq.score;
      //                     if (item.self_answer != undefined) {
      //                       let type = gq.typeCode;
      //                       if (type == "A" || type == "C") {
      //                         gq.self_answer = item.self_answer;
      //                       }
      //                       if (type == "B") {
      //                         // let temp = item.self_answer.replace(
      //                         //   /\'([A-G])\'/gi,
      //                         //   "$1"
      //                         // );
      //                         // gq.self_answer = temp
      //                         //   .slice(2, temp.length - 2)
      //                         //   .split(",");
      //                         gq.self_answer = item.self_answer;
      //                       }
      //                       if (type == "C") {
      //                       }
      //                       if (type == "E") {
      //                         gq.self_answer = item.self_answer;
      //                       }
      //                       if (type == "S") {
      //                         gq.self_answer = item.self_answer;
      //                       }
      //                     }
      //                     // if (!(majorTypes.indexOf(gq.typeCode) == -1)) {
      //                     //   // major_question_count++;
      //                     //   // major_quesiton_score += gq.score;
      //                     //   // if (!item.auditStatus) {
      //                     //   //   major_unaduit_score += gq.score;
      //                     //   // }
      //                     //   // if (item.correct) {
      //                     //   //   // major_correct_score += gq.score;
      //                     //   // } else {
      //                     //   //   major_error_score += gq.score;
      //                     //   // }
      //                     // } else {
      //                     //   // objective_question_count++;
      //                     //   // objective_question_score += gq.score;
      //                     //   if (item.correct) {
      //                     //     objective_correct_score += gq.score;
      //                     //   } else {
      //                     //     objective_error_score += gq.score;
      //                     //   }
      //                     // }

      //                     if (!this.newqs.hasOwnProperty(gq.original)) {
      //                       this.$set(this.newqs, gq.original, [])
      //                       this.newqs[gq.original].push({
      //                         index: ++this.newqsIndex,
      //                         name: gq.originalName.trim(),
      //                         status: item.correct,
      //                         id: gq.id,
      //                         original: gq.original
      //                       })
      //                     } else {
      //                       this.newqs[gq.original].push({
      //                         index: ++this.newqsIndex,
      //                         name: gq.originalName.trim(),
      //                         status: item.correct,
      //                         id: gq.id,
      //                         original: gq.original
      //                       })
      //                     }
      //                   }
      //                 });
      //               }
      //             });
      //           }
      //         });
      //       }
      //       if (gkpaper.gkQuestions != undefined) {
      //             gkpaper.gkQuestions.forEach((gq) => {
      //               if (gq.typeCode == "M") {
      //                 qc += gq.subQuestions.length;
      //                 gq.subQuestions.forEach((sq) => {
      //                   sq.questionOrder = order++;
      //                   qs.forEach((item) => {
      //                     if (item.id == sq.id) {
      //                       item.originalName = sq.originalName
      //                       item.parent_id = gq.original;
      //                     item.parent_typeId = gq.typeId;
      //                       sq.note = item.note;
      //                       item.order = sq.original;
      //                       sq.self_answer = item.self_answer;
      //                       sq.self_score = item.score;
      //                       sq.auditStatus = item.auditStatus;
      //                       sq.correct = item.correct;
      //                       sq.tempAuditStatus = item.auditStatus;
      //                       this.allscore += sq.score;
      //                       sq.paper_id = this.questionSubmitInfo.paper_id;
      //                       sq.test_id = this.questionSubmitInfo.test_id;
      //                       // if (!(majorTypes.indexOf(sq.typeCode) == -1)) {
      //                       //   // major_question_count++;
      //                       //   // major_quesiton_score += sq.score;
      //                       //   // if (!item.auditStatus && item.status) {
      //                       //   //   major_unaduit_score += sq.score;
      //                       //   // }
      //                       //   // if (item.correct && item.status) {
      //                       //   //   // major_correct_score += item.score;
      //                       //   // } else {
      //                       //   //   major_error_score += item.score;
      //                       //   // }
      //                       // } else {
      //                       //   // objective_question_count++;
      //                       //   // objective_question_score += sq.score;
      //                       //   if (item.correct) {
      //                       //     // objective_correct_score += sq.score;
      //                       //   } else {
      //                       //     objective_error_score += sq.score;
      //                       //   }
      //                       // }

      //                       if (!this.newqs.hasOwnProperty(gq.original)) {
      //                         this.$set(this.newqs, gq.original, [])
      //                         this.newqs[gq.original].push({
      //                           index: ++this.newqsIndex,
      //                           name: sq.originalName.trim(),
      //                           status: item.correct,
      //                           id: sq.id,
      //                           original: sq.original
      //                         })
      //                       } else {
      //                         this.newqs[gq.original].push({
      //                           index: ++this.newqsIndex,
      //                           name: sq.originalName.trim(),
      //                           status: item.correct,
      //                           id: sq.id,
      //                           original: sq.original
      //                         })
      //                       }
      //                     }
      //                   });
      //                 });
      //               } else {
      //                 gq.questionOrder = order++;
      //                 qc++;
      //                 qs.forEach((item) => {
      //                   if (item.id == gq.id) {
      //                     item.originalName = gq.originalName;
      //                     item.parent_id = gq.original;
      //                     item.parent_typeId = gq.typeId;
      //                     gq.note = item.note;
      //                     gq.self_score = item.score;
      //                     gq.auditStatus = item.auditStatus;
      //                     gq.correct = item.correct;
      //                     item.order = gq.original;
      //                     gq.paper_id = this.questionSubmitInfo.paper_id;
      //                     gq.test_id = this.questionSubmitInfo.test_id;
      //                     gq.tempAuditStatus = item.auditStatus;
      //                     this.allscore += gq.score;
      //                     if (item.self_answer != undefined) {
      //                       let type = gq.typeCode;
      //                       if (type == "A" || type == "C") {
      //                         gq.self_answer = item.self_answer;
      //                       }
      //                       if (type == "B") {
      //                         gq.self_answer = item.self_answer;
      //                       }
      //                       if (type == "C") {
      //                       }
      //                       if (type == "E") {
      //                         gq.self_answer = item.self_answer;
      //                       }
      //                       if (type == "S") {
      //                         gq.self_answer = item.self_answer;
      //                       }
      //                     }
      //                     // if (!(majorTypes.indexOf(gq.typeCode) == -1)) {
      //                     //   // major_question_count++;
      //                     //   // major_quesiton_score += gq.score;
      //                     //   // if (!item.auditStatus) {
      //                     //   //   major_unaduit_score += gq.score;
      //                     //   // }
      //                     //   // if (item.correct) {
      //                     //   //   // major_correct_score += gq.score;
      //                     //   // } else {
      //                     //   //   major_error_score += gq.score;
      //                     //   // }
      //                     // } else {
      //                     //   // objective_question_count++;
      //                     //   // objective_question_score += gq.score;
      //                     //   if (item.correct) {
      //                     //     objective_correct_score += gq.score;
      //                     //   } else {
      //                     //     objective_error_score += gq.score;
      //                     //   }
      //                     // }

      //                     if (!this.newqs.hasOwnProperty(gq.original)) {
      //                       this.$set(this.newqs, gq.original, [])
      //                       this.newqs[gq.original].push({
      //                         index: ++this.newqsIndex,
      //                         name: gq.originalName.trim(),
      //                         status: item.correct,
      //                         id: gq.id,
      //                         original: gq.original
      //                       })
      //                     } else {
      //                       this.newqs[gq.original].push({
      //                         index: ++this.newqsIndex,
      //                         name: gq.originalName.trim(),
      //                         status: item.correct,
      //                         id: gq.id,
      //                         original: gq.original
      //                       })
      //                     }
      //                   }
      //                 });
      //               }
      //             });
      //       }
      //       let chooseQuestion = [];
      //       qs.forEach(q=>{
      //         if(q.parent_typeId != 229 && q.parent_typeId != 234){
      //           this.self_score += q.score;
      //         }else{
      //           chooseQuestion.push(q);
      //         }
      //       })

      //       let map = new Map();
      //       //解决选做题的分数
      //       for (let i = 0; i < chooseQuestion.length; i++) {
      //         let item = chooseQuestion[i];
      //         if(null == map.get(item.parent_id)){
      //           let array = new Array();
      //           array.push(item)
      //           map.set(item.parent_id,array)
      //         }else{
      //           let array = map.get(item.parent_id);
      //           array.push(item);
      //         }
      //       }

      //       map.forEach(value=>{
      //         value.sort((o1,o2)=>{return o2.score - o1.score})
      //         this.self_score += value[0].score
      //       })


      //       this.questionStatus = qs;
      //       this.question_num = qc;
      //       this.question_tab = qs[0].order;
      //       this.$root.eventHub.$emit("question-tab-changed",qs[0].order);
            
      //       this.interval();
      //     }
      //   });
    },
    formatSeconds(value) {
        var theTime = parseInt(value);// 秒
        var theTime1 = 0;// 分
        var theTime2 = 0;// 小时
        // alert(theTime);
        if(theTime > 60) {
            theTime1 = parseInt(theTime/60);
            theTime = parseInt(theTime%60);
            // alert(theTime1+"-"+theTime);
            if(theTime1 > 60) {
                theTime2 = parseInt(theTime1/60);
                theTime1 = parseInt(theTime1%60);
            }
        }
        var result = ""+parseInt(theTime)+"秒";
        if(theTime1 > 0) {
            result = ""+parseInt(theTime1)+"分"+result;
        }
        if(theTime2 > 0) {
            result = ""+parseInt(theTime2)+"小时"+result;
        }
        return result;
    },
    
    getTestId() {
      // 取存的值
      let str = JSON.stringify(this.$store.state.paper_data)
      // let paper_data = this.$store.state.paper_data || null  不作答提交有大问题
      let paper_data = null
      if (paper_data != null && (paper_data.test_id == this.$route.query.test_id)) {
        this.tset_id = this.$route.query.test_id;
        this.paper_id = paper_data.paper_id;
        window.localStorage.setItem("test_id", this.$route.query.test_id);
        let userInfo = window.localStorage.getItem("userinfo");
        let user = JSON.parse(userInfo);
        this.questionSubmitInfo = {
          paper_id: paper_data.paper_id,
          test_id: this.$route.query.test_id,
          user_id: user.id,
        };
        str = str
          .replace(/testId/g, "test_id")
          .replace(/completionStatus/g, "status")
          // .replace(/answer/g, "self_answer")
          .replace(/self_answer/g, "answer")
          .replace(/([^\/])answer/g, "$1self_answer")
          .replace(/questionId/g, "id");
        let qs = JSON.parse(str);
        //已经做题的数量
        let count = 0;
        for (let h = 0; h < qs.questions.length; h++) {
          if (qs.questions[h].auditStatus == true || qs.questions[h].audit_status == true) {
            count++;
            // this.self_score += qs.questions[h].score;
          }
        }
        this.answer_time = this.formatSeconds((localStorage.getItem(`time_${this.questionSubmitInfo.paper_id}`)/1000));
        this.answer_count = count;
        // this.self_score
        this.initPage(qs.questions)
      } else {
        const data = {
          test_id: this.$route.query.test_id,
        };
        this.$HTTP
        .executePost(this.$APIS.GET_TEST_BY_TESTDETAIL, data, this)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.testQuestions.length) {
              setTimeout(() => {
                this.getTestId()
              }, 2000)
            } else {
              //显示app的类型
            let app_id = res.data.typeCode;
            if (app_id == 4) {
              this.app_name = "摸底考试";
            }
            if (app_id == 11) {
              this.app_name = "基础夯实";
            }
            if (app_id == 21) {
              this.app_name = "专题强化";
            }
            if (app_id == 3) {
              this.app_name = "查漏补缺";
            }
            if (app_id == 2) {
              this.app_name = "考前冲刺";
            }
            this.tset_id = res.data.id;
            this.paper_id = res.data.paperId;
            window.localStorage.setItem("test_id", res.data.id);
            let userInfo = window.localStorage.getItem("userinfo");
            let user = JSON.parse(userInfo);
            this.questionSubmitInfo = {
              paper_id: res.data.paperId,
              test_id: res.data.id,
              user_id: user.id,
            };
            // order: sq.original,
            // status: false,
            // correct : false,

            // score : 0,
            // self_answer: '',
            // answer: sq.answer.trimHeadTailTag("p"),
            // id: sq.id,
            // audit_status : false//批改状态
            let arr = res.data.testQuestions;
            let str1 = JSON.stringify(arr);
            str1 = str1
              .replace(/testId/g, "test_id")
              .replace(/completionStatus/g, "status")
              .replace(/self_answer/g, "answer")
              .replace(/([^\/])answer/g, "$1self_answer")
              .replace(/questionId/g, "id");
            let qs = JSON.parse(str1);
            //已经做题的数量
            let count = 0;
            for (let h = 0; h < qs.length; h++) {
              if (qs[h].auditStatus == true || qs[h].audit_status == true) {
                count++;
                // this.self_score += qs[h].score;
              }
            }
            this.answer_count = count;
            this.initPage(qs);
            this.answer_time = this.formatSeconds((res.data.timeUsed ? res.data.timeUsed :(res.data.endTime - res.data.startTime) )/ 1000)
            }
          } else {
            this.$message.error("请求试卷失败!");
          }
        });
       
      }
    },
    // 页面滚动
    // handleScroll(o, ind) {
      // let s = "#anchor" + o;
      // let qs = document.querySelector(s);
      // if (qs == undefined) return;
      // document.querySelector(s).scrollIntoView(true);
      // this.activeIindex = ind
      // const gap = document.documentElement.scrollTop || document.body.scrollTop;
      // scrollTo(0,gap-175)
    // },
  },
  created() {
    // 兼容客户端
    this.model = localStorage.getItem('model')
  },
  mounted() {
    // this.getTestId();
    this.initPage();
    //监控答案的改动
    this.$root.eventHub.$on(
      "self-assessment-changed",
      (original, score, auditStatus, correct) => {
        //题的状态
        let i = 0;
        for (var j = 0; j < this.questionStatus.length; j++) {
          if (this.questionStatus[j].order == original) {
            i = j;
            break;
          }
        }
        this.questionStatus[i].correct = correct;
        this.questionStatus[i].audit_status = auditStatus;
        this.questionStatus[i].score = score;
        //已经做题的数量
        let count = 0;
        this.self_score = 0;

        for (let h = 0; h < this.questionStatus.length; h++) {
          if (
            this.questionStatus[h].audit_status == true ||
            this.questionStatus[h].auditStatus == true
          ) {
            count++;
            this.self_score += Number(this.questionStatus[h].score);
          }
        }
        this.answer_count = count;
      }
    );

    //监控答题卡传过来的question id
    this.$root.eventHub.$on("question-tab-changed", (val) => {
      this.question_tab = val;
    });

    setTimeout(() => {
      const _this = this;
      this.imgs = []
      this.img_tags = []
      let viewLength = $('._view_image')
      for (let j = 0; j < viewLength.length; j++) {
        $('._view_image')[j].onclick= function() {
          _this.typeEdit = []
          _this.imgs = []
          _this.img_tags =$(this).find("img");
          for (let i = 0; i < _this.img_tags.length; i++) {
            if (_this.img_tags[i].src == this.src) {
              _this.imgIndex = i;
            }
            _this.imgs.push(_this.img_tags[i].src);
          }
          _this.imgIndex = _this.imgIndex;
          _this.url = _this.imgs[_this.imgIndex];
          _this.imgs.splice(_this.imgIndex,1)
          _this.imgs.unshift(_this.url)
          if (_this.imgs[0] && _this.imgs[0] != undefined) {
            _this.dialogVisiblePic = true;
          }
        }
      }
    }, 5000)
  },
  destroyed() {
    this.$store.dispatch('actionsSetPaperData', null);
    // localStorage.setItem('paper_data', null)
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-image-viewer__canvas img {
  background-color: #fff !important;
}
  /deep/ .pic-dialog {
    width: 800px;
    height: 950px;
    z-index: 999;

    .el-dialog__header {
      width: 100%;
      height: 50px;
      position: relative;
      float: left;
      padding : 0;
      line-height : 50px;
      text-align : center;
    }

    .el-dialog__body {
      width: 100%;
      height: 900px;
      position: relative;
      float: left;
      padding : 0;
      top : 0;
      ::-webkit-scrollbar {
        width: 0 !important;
      }
      ::-webkit-scrollbar {
        width: 0 !important;height: 0;
      }

      .left {
        width: 15%;
        height: 100%;
        position: relative;
        float: left;
        display:flex;
        justify-content: center;
        align-items: center;
        .prev{
          width :auto;
          height : auto;
          .el-button el-button--primary{
            color: #FFF;
            border: none;
          }
          .el-button{
            color: #FFF;
            border: none;
            width : 50px;;
            height : 50px;
            border-radius : 25px;
            padding : 0;
            margin : 0;
            .el-icon-arrow-left{
              font-size : 28px;
            }
          }
        }
      }

      /deep/ .img {
        width: 70%;
        height: 90%;
        position: relative;
        float: left;
        display:flex;
        justify-content: center;
        align-items: center;
        overflow-y : scroll;
        padding-top : 5%;
        padding-bottom : 5%;
        /deep/ img{
          width : 100% !important;
        }
      }

      .edit {
          width: 100%;
          height: auto;
          text-align: center;
          position: absolute;
          bottom: 0;
        }

      .right {
        width: 15%;
        height: 100%;
        position: relative;
        float: left;
        display:flex;
        justify-content: center;
        align-items: center;
        .next{
          width :auto;
          height : auto;
          .el-button el-button--primary{
            color: #FFF;
            border: none;
          }
          .el-button{
            color: #FFF;
            border: none;
            width : 50px;;
            height : 50px;
            border-radius : 25px;
            padding : 0;
            margin : 0;
            .el-icon-arrow-right{
              font-size : 28px;
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
/deep/ .loading_color{
  .el-icon-loading {
    color: #5c307d !important;
    font-size: 60px !important;
  }
  .el-loading-text {
    color: #5c307d !important;
    font-size: 20px !important;
  }
}
.paper_page {
  width: 1920px;
  height: 100%;
  position: absolute;

  .charts {
    height: 300px;
    width: 800px;
    margin-top: 40px;
  }

  .header_paper {
    width: 1920px;
    height: 81px;
    color: #ffffff;
    background: #5c307d;
    position: fixed;
    z-index: 999;

    .logo_paper {
      width: 150px;
      margin-top: 16px;
      margin-left: 40px;
      float: left;

      img {
        width: 150px;
      }
    }

    .paper_name {
      width: 1774px;
      height: 32px;
      font-size: 32px;
      line-height: 32px;
      text-align: center;
      margin-top: 22px;
      margin-left: -138px;
    }
  }

  .bread {
    width: 1920px;
    height: 70px;
    line-height: 70px;
    font-size: 21px;
    margin-top: 81px;
    background-color: #ffffff;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: #5c307d;
    position: fixed;
    z-index: 40;
    color: #5c307d;
    display: inline-flex;
    justify-content: space-between;
    .first {
      margin-left: 30px;
    }
    .last {
      cursor: auto;
    }

    .divs {
      float: left;
      // margin-left: 90px;
      margin-left: 130px;

      /deep/ .el-select {
        width: 120px;

        .el-input.is-focus .el-input__inner {
          border-color: #5c307d;
        }

        .el-input__inner {
          font-size: 16px;
        }
      }
    }
    .test_padding {
      margin-right: 100px;
    }
    span {
      text-align: center;
      float: left;
      font-size: 21px;
      cursor: pointer;
    }

    .text {
      color: #8d8d8d;
      cursor: auto;
    }

    .value {
      color: #5c307d;
      cursor: auto;
    }
  }

  .main {
    width: 1920px;
    height: auto;
    position: absolute;
    background-color: #ffffff;
    margin-top: 153px;
    margin-left : 15px;
    padding-bottom : 30px;
    // overflow-y : auto;
    .paper {
      width: 1563px;
      float: left;
      position: absolute;
      .desc-info {
        font-size: 26px;
        background-color: #fff;
        line-height: 50px;
        text-align: center;
      }
    }

    .loading {
      width: 1563px;
      height: 727px;
      position: absolute;
      margin-top: 0px;
      position: relative;
      float: left;
    }

    .aside {
      clear: both;
      width: 300px;
      background-color: #f5f5f5;
      margin-left: 1551px;
      position: absolute;
    }
  }
  
  >>> .el-dialog__wrapper {

    .paper-info-dialog {
      height: 600px;

      .button {
        position: absolute;
        bottom: 50px;
        right: 20px;
        background-color: #1890FF;
        width: auto;
        height: 20px;
        line-height: 20px;
        border-radius: 5px;

        .el-button {
          font-size: 18px;
          // background-color : #1890FF;
          // color : black;
        }
      }

      .info {
        position: absolute;
        bottom: 50px;
        width: 50%;
        left: 100px;
        height: 100px;

        .major {
          height: 20px;
          position: relative;

          .item {
            white-space: nowrap;
            position: relative;
            width: auto;

            .blue_circle {
              height: 10px;
              width: 10px;
              border-radius: 5px;
              background-color: #0EABF1;
              position: relative;
              float: left;
              margin-top: 5px;
            }

            .text {
              float: left;
              position: relative;
              line-height: 20px;
            }
          }
        }

        .objective {
          position: relative;

          .item {
            white-space: nowrap;
            width: auto;
            height: 20px;

            .text {
              float: left;
              position: relative;
              line-height: 20px;
            }

            .green_circle {
              height: 10px;
              width: 10px;
              border-radius: 5px;
              background-color: #85D633;
              position: relative;
              float: left;
              margin-top: 5px;
            }

            .radio_circle {
              height: 10px;
              width: 10px;
              border-radius: 5px;
              background-color: #85D633;
              position: relative;
              float: left;
              margin-top: 5px;
              margin-left: 15px;
            }

            .multi_circle {
              height: 10px;
              width: 10px;
              border-radius: 5px;
              background-color: #A3E066;
              position: relative;
              float: left;
              margin-top: 5px;
              margin-left: 15px;
            }

            .judge_circle {
              height: 10px;
              width: 10px;
              border-radius: 5px;
              background-color: #C2EB99;
              position: relative;
              float: left;
              margin-top: 5px;
              margin-left: 15px;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="stylus" scoped>
.font-set {
  .el-select-dropdown__wrap {
    max-height: none;
  }

  .el-scrollbar__wrap {
    .el-select-dropdown__list {
      .el-select-dropdown__item {
        height: 50px;
        line-height: 50px;
      }

      .el-select-dropdown__item:nth-child(1) {
        font-size: 18px;
      }

      .el-select-dropdown__item:nth-child(2) {
        font-size: 20px;
      }

      .el-select-dropdown__item:nth-child(3) {
        font-size: 22px;
      }

      .el-select-dropdown__item:nth-child(4) {
        font-size: 24px;
      }

      .el-select-dropdown__item:nth-child(5) {
        font-size: 26px;
      }
    }
  }
}
</style>
<style lang="scss">
.el-image-viewer__wrapper {
  .el-image-viewer__close {
    color: #fff;
  }
}
</style>
